import { defineMessages } from 'react-intl';

export default defineMessages({
  title_suivre_sinistre: {
    id: 'dashboard_auto.title_suivre_sinistre',
  },
  title_declarer_sinistre: {
    id: 'dashboard_auto.title_declarer_sinistre',
  },
  title_contracts_garanties: {
    id: 'dashboard_auto.title_contracts_garanties',
  },
  title_ajout_contrat: {
    id: 'dashboard_auto.title_ajout_contrat',
  },
  title_offres_conseils: {
    id: 'dashboard_auto.offres_conseils_title',
  },
  title_offre1: {
    id: 'dashboard_auto.offres_conseils_offre1_title',
  },
  content_offre1: {
    id: 'dashboard_auto.offres_conseils_offre1_content',
  },
  buttonLabel_offre1: {
    id: 'dashboard_auto.offres_conseils_offre1_button',
  },
  title_offre2: {
    id: 'dashboard_auto.offres_conseils_offre2_title',
  },
  content_offre2: {
    id: 'dashboard_auto.offres_conseils_offre2_content',
  },
  buttonLabel_offre2: {
    id: 'dashboard_auto.offres_conseils_offre2_button',
  },
  title_offre3: {
    id: 'dashboard_auto.offres_conseils_offre3_title',
  },
  content_offre3: {
    id: 'dashboard_auto.offres_conseils_offre3_content',
  },
  buttonLabel_offre3: {
    id: 'dashboard_auto.offres_conseils_offre3_button',
  },
  title_offre4: {
    id: 'dashboard_auto.offres_conseils_offre4_title',
  },
  content_offre4: {
    id: 'dashboard_auto.offres_conseils_offre4_content',
  },
  buttonLabel_offre4: {
    id: 'dashboard_auto.offres_conseils_offre4_button',
  },
  declarer_Sinistre: {
    id: 'dashboard_mrh.que_faire_en_cas_sinistre',
  },
  declarer_Sinistre_title: {
    id: 'dashboard_auto.declarer_sinistre_title',
  },
  declarer_Sinistre_description: {
    id: 'dashboard_auto.declarer_sinistre_description',
  },
  contactAgentService: {
    id: 'dashboard_auto.contact_service',
  },
  contactAgent: {
    id: 'dashboard_auto.contact_agent_numero',
  },
  contactEmail: {
    id: 'dashboard_auto.contact_email',
  },
  close: {
    id: 'modal.close',
  },
});
